import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="module-storage-filetypes" id="module-storage-filetypes"></a>
    <h1 {...{
      "id": "requireuxpstoragefiletypes"
    }}>{`require('uxp').storage.fileTypes`}</h1>
    <a name="new-module-storage-filetypes-new" id="new-module-storage-filetypes-new"></a>
    <h2 {...{
      "id": "filetypes"
    }}>{`fileTypes()`}</h2>
    <p>{`This namespace describes the various file type extensions that can used be used in some FS file open methods.`}</p>
    <a name="module-storage-filetypes-text" id="module-storage-filetypes-text"></a>
    <h2 {...{
      "id": "text--arraystring"
    }}>{`text : `}<inlineCode parentName="h2">{`Array<string>`}</inlineCode></h2>
    <p>{`Text file extensions`}</p>
    <a name="module-storage-filetypes-images" id="module-storage-filetypes-images"></a>
    <h2 {...{
      "id": "images--arraystring"
    }}>{`images : `}<inlineCode parentName="h2">{`Array<string>`}</inlineCode></h2>
    <p>{`Image file extensions`}</p>
    <a name="module-storage-filetypes-all" id="module-storage-filetypes-all"></a>
    <h2 {...{
      "id": "all--arraystring"
    }}>{`all : `}<inlineCode parentName="h2">{`Array<string>`}</inlineCode></h2>
    <p>{`All file types`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      